

import {Component, Vue} from "vue-property-decorator";
import {HubConnectionBuilder} from "@microsoft/signalr";
import api from '@/api'

@Component({
  name:'SubscribeConfiguration'
})
export default class SubscribeConfiguration extends Vue {


  qrCodeImageUrl = '';
  scanResult = ''
  ticket = ''
  saving = false;
  loading = true;
  isSubscribed = false;


  async created(){
    this.isSubscribed = await api.wechatMessageSubscribe.isSubscribed();
    debugger
    if(!this.isSubscribed){
      this.startSignalR();
    } else {
      this.loading = false;
    }
  }



  startSignalR(){
    const hubUrl = `${process.env.VUE_APP_BASE_API}/WechatMessageSubscribeHub`
    const connect = new HubConnectionBuilder()
                  .withUrl(hubUrl)
                  .build();

    connect.on('refreshQrCodeImage',url=>{
      this.qrCodeImageUrl = url;
      this.loading = false;
    })


    connect.on('completed',ticket=>{
      this.ticket = ticket;
      this.subscribe();
    })

    connect.start()

  }

  subscribe(){
    this.saving = true;
    api.wechatMessageSubscribe.subscribe({body:{ticket:this.ticket}}).then(()=>{
      this.saving = false;
      this.isSubscribed = true;
    })
  }

  cancelSubscribe(){
    api.wechatMessageSubscribe.cancelSubscribe().then(()=>{
      this.$message.success('您已成功取消');
    })
  }

}

